module.exports = __webpack_public_path__ + "static/media/iconM7.6f46393c.svg";